import { render, staticRenderFns } from "./ApproveAndSign.vue?vue&type=template&id=b16daad8&scoped=true&"
import script from "./ApproveAndSign.vue?vue&type=script&lang=js&"
export * from "./ApproveAndSign.vue?vue&type=script&lang=js&"
import style0 from "./ApproveAndSign.vue?vue&type=style&index=0&id=b16daad8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16daad8",
  null
  
)

export default component.exports